import React, {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import axios from 'axios';


const options = {
	
	chart: {
        type: 'packedbubble',
        backgroundColor: '#121212'        
    },

    tooltip: {
		enabled: false    
    },
    
    title: {
	    text: '',
		style: {
			color: 'white',
			fontWeight: 'bold',
			fontSize: 30,
			opacity: 0.30
		}
    },
    
    plotOptions: {
        packedbubble: {
            minSize: '20%',
            maxSize: '140%',
            layoutAlgorithm: {
                splitSeries: false,
                gravitationalConstant: 0.02
            },

		    dataLabels: {
		        enabled: true,
		        format: '{point.name}',
		        style: {
		            color: 'white',
		            textOutline: 'none',
		            fontWeight: 'bold'
		        }
		    }
		                
        },
	    series: {
		    point: {
			    events: {
					click: function(e) {
						window.open("https://finance.yahoo.com/chart/" + e.point.name, '_blank');									
	                }			
	            }
			}
	    }			        
                
    }
	
}


function Stonks() {
	const chartRef = useRef();		
    const location = useLocation();	
	var industry;

	industry = location.state.detail;    
		
	useEffect(() => {
		var stocks;

		chartRef.current.chart.setTitle({text: industry}, '', false);
		chartRef.current.container.current.style.height = "100%";
		chartRef.current.chart.reflow();

		const getStocks = async () => {
		    var url = "http://155.4.97.54:3000/stonks/" + industry;
		    
		 	const response = await axios.get(url);
		    
		    stocks = response.data;
		}
		
		getStocks().then(() => {
			var i;
			var val;
			var s = [{name: 'Plus', color: '#27e8a7', data: []}, {name: 'Minus', color: '#cf6679', data: []}];
									
			for (i = 0; i < stocks.length; i++) {
				
				if (stocks[i].volym > 0 && stocks[i].hastighet > 0) {
					val = stocks[i].volym + Math.pow(stocks[i].hastighet, 2);
					s[0].data.push({name: stocks[i].symbol, value: val});
				}
				else {
					val = stocks[i].volym - Math.pow(stocks[i].hastighet, 2);
					s[1].data.push({name: stocks[i].symbol, value: val});					
				}
			}

			chartRef.current.chart.addSeries(s[0]);
			chartRef.current.chart.addSeries(s[1]);			
			
		})
		.catch((e) => {
			console.log("Err: getStocks", e.message);
		})
		
    }, [industry]);

    return (
        <div id="container">
			<HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />	            	        
	    </div>
    )	    

};


export default Stonks;